import { ButtonGroupProps } from "../types";

export const ButtonGroup = ({ onCancel, onAdd, selectedMicroLessons }: ButtonGroupProps) => {
  return (
    <div className="button-group-container">
      <button className="secondary" onClick={onCancel}>
        Cancel
      </button>
      <button disabled={selectedMicroLessons.length === 0} className="primary" onClick={onAdd}>
        Add to Page
      </button>
    </div>
  );
};
